import storage from './storage';

export const tokenKey = 'X-KEA-SESSION-TOKEN';

export const setToken = storage.sessionToken.set;
export const getToken = storage.sessionToken.get;
export const rmToken = storage.sessionToken.remove;
